import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-voorzieningen-vervoer',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVoorzieningenVervoer {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M7.02 15.5c0-1.38 1.12-2.5 2.49-2.5S12 14.12 12 15.5 10.88 18 9.51 18s-2.49-1.12-2.49-2.5M5.33 33.85a4.45 4.45 0 0 1-3.18-3.18c-.57-2.23.54-4.27 2.33-5.17.33-.17.52-.51.52-.88 0-.76-.8-1.25-1.47-.9-2.4 1.24-3.94 3.93-3.43 6.91.45 2.66 2.6 4.81 5.26 5.27 2.98.51 5.67-1.03 6.91-3.43.34-.67-.14-1.47-.89-1.47-.37 0-.71.2-.88.52a4.499 4.499 0 0 1-5.17 2.33m9.7-7.85H12v-3.86c0-1.3-.93-2.49-2.22-2.63A2.516 2.516 0 0 0 7 22v4.53C7 27.89 8.11 29 9.47 29H15v6c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-6.03c0-1.64-1.34-2.97-2.97-2.97M36 15c0 .55-.45 1-1 1s-1-.45-1-1v-2H19v2c0 .55-.45 1-1 1s-1-.45-1-1V8.94c0-.7.37-1.3.92-1.65l1.14-5.78C19.28.62 20.08 0 21 0h11c.92 0 1.72.62 1.94 1.51l1.13 5.8c.55.35.92.97.92 1.67v6.01ZM20 7h13l-1-5H21zm1 3c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1m9-1h-7v2h7zm4 1c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1"/>
</svg>

    );
  }
}
